import React, { useState, useRef, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import PrivacyPolicyPage from "../../Pages/PrivacyPolicy/PrivacyPolicyPage";
import { Modal, Button } from "react-bootstrap";

// import { FaMicrophone } from "react-icons/fa";
import { IconButton } from "@mui/material";
import "./Chatbot.css";
import axiosInstance from "../../Services/axiosInstance";
import { ToastContainer, toast } from "react-toastify";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm"; // For GitHub Flavored Markdown (e.g., tables, strikethrough)
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import newChat from "../../images/new.png";
import { setSessionId } from "../../Services/ChatSession/sessionSlice";
import { useDispatch } from "react-redux";
import { FaMicrophone, FaThumbsUp, FaThumbsDown } from "react-icons/fa";
import { ReactComponent as ThumbsUpIcon } from "../../../src/images/like.svg";
import { ReactComponent as ThumbsDownIcon } from "../../../src/images/dislike.svg";
import {
  setChatHistory,
  addMessage,
  setClearAns,
} from "../../Services/ChatSession/chatHistorySlice";
import axios from "axios";
import { useSelector } from "react-redux";
import {
  setSessionData,
  setClearSessionData,
  setMessageData,
  storeSessionResponse,
  appendFirstChat,
} from "../../Services/ChatSession/chatDataSlice";
import { updateCommunityApi } from "../../Services/Community/CommunityAPI/communityApi";
import { acceptPrivacyPolicyApi, submitFeedBackApi, submitQuery } from "../../Apis/chatServices";

const Chatbot = () => {
  const { isCollapsed, setRefetch } = useOutletContext();
  const chatHistory = useSelector((state) => state.chatHistory);
  // const sessionData = useSelector((state) => state.chatMessages.sessionData); //  Sidebar data safe
  const clearAns = useSelector((state) => state.chatHistory.clearAns); //  Sidebar data safe
  const userDetails = useSelector(
    (state) => state.fetchProfileData?.data?.data
  );

  const sessionResponse = useSelector((state) => state.session.sessionResponse);

  const sessionData = useSelector((state) => state.chatMessages.sessionData);
  const seesionId = useSelector((state) => state.session.sessionId); // Get chat data
  // Get chat data
  const userId = localStorage.getItem("user_id");
  const [filteredChatHistory, setFilteredChatHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const status = userDetails?.status; // Extract status
  const [likedMessages, setLikedMessages] = useState(new Set());
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const [feedbackMap, setFeedbackMap] = useState({});
  const [feedbackData, setFeedbackData] = useState({});
  const [response, setResponse] = useState(null);
  // State to manage checkbox value
  const [acceptPolicy, setAcceptPolicy] = useState(false);

  // Event handler to update state when checkbox is toggled
  const handleAcceptPolicyChange = (event) => {
    setAcceptPolicy(event.target.checked);
  };

  const handleFeedback = (index, type, messageData) => {
    
    setFeedbackData(messageData);
    setFeedbackMap((prev) => ({
      ...prev,
      [index]: type, // Save feedback per message index
    }));
    setFeedbackType(type);
    setSelectedFeedback(index);
    setShowPopup(true);
  };

  useEffect(() => {
    if (status === "deactivated") {
     

      localStorage.removeItem("access_token");
      localStorage.removeItem("accessToken");
    }
  }, [status]);
    const location = useLocation();
  const { is_privacy_policy_accepted } = location.state || {};

 const [show, setShow] = useState(localStorage.getItem("is_privacy_policy_accepted") === "false" ? true : false);
 console.log("is_privacy_policy_accepted", is_privacy_policy_accepted);
 console.log(show , "show state ==========================>");
  useEffect(() => {
    // Show modal as soon as component loads
    
    // setShow(localStorage.getItem("read_privacy") === "false" ? true : false);
  }, []);

  const handleClose = () =>{
    localStorage.setItem("read_privacy", "true");
    setShow(false);
  } 
  const handleAcceptPolicy = async() => {
    // localStorage.setItem("read_privacy", "true");
    if (!acceptPolicy) {
      toast.error("You must accept the privacy policy to proceed.");
      return;
    }
    try {
      const res = await acceptPrivacyPolicyApi({is_privacy_policy_accepted: true , user_id: userId});
      console.log(res, "acceptPrivacyPolicyApi response ======================>");
      localStorage.setItem("is_privacy_policy_accepted", "true");
      navigate('/user/change-password')
    } catch (error) {
      console.error("Error accepting privacy policy:", error);
    }
    // called api to accept the privacy policy
    setShow(false);
  };

 
  // console.log("sessionData-=-=-=-=-=-=", sessionData)

  // console.log("isCollapsed===", isCollapsed);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [isListening, setIsListening] = useState(false);
  const [recognition, setRecognition] = useState(null);
  const textareaRef = useRef(null);

  const dispatch = useDispatch();
  const chatWindowRef = useRef(null);
  const [usedToken, setUsedToken] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [feedbackType, setFeedbackType] = useState(""); // 'like' or 'dislike'
  const [feedbackMessageId, setFeedbackMessageId] = useState(null);
  // Default to empty object to prevent errors if state is undefined
  let sessionId = useSelector((state) => state.session.sessionId); // Get session_id from Redux
  const message = messages[feedbackMessageId];

  

  const handleSubmitFeedback = async () => {
   
    try {
      const data = {
        user_id: Number(userId),
        user_query: feedbackData?.user_query|| input,
        assistant_response: feedbackData.text,
        session_id: sessionId,
        is_liked: feedbackType === "thumbsUp",
      };
      


      await submitFeedBackApi(data);

      // await fetch("https://sdeiaiml.com:9034/chat/upload_question/", {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   body: JSON.stringify({
      //     user_id: Number(userId),
      //     user_query: feedbackData.user_query,
      //     assistant_response: feedbackData.text,
      //     session_id: sessionId,
      //     is_liked: feedbackType === "thumbsUp",
      //   }),
      // });
      toast.success("Feedback submitted!");
    } catch (error) {
      toast.error("Failed to submit feedback");
      console.error("Feedback error:", error);
    } finally {
      setShowPopup(false);
      setFeedbackType("");
      setFeedbackMessageId(null);
    }
  };

  useEffect(() => {
    if (!sessionId) {
      // Check if session_id does NOT exist
      const id = generateRandomNumber();
     
      dispatch(setSessionId(id)); // Dispatch only if session_id is not present
     
    }
    if (sessionData) {
      // setMessages(sessionData)
    }
  }, [sessionId, dispatch]); // Add dependencies


  // Effect to clear messages when clearAns is true
  useEffect(() => {
    if (clearAns) {
      
      setMessages([]); // Clears the messages
      dispatch(setClearAns(false)); // Reset clearAns after clearing
    }
  }, [clearAns, dispatch]); // Runs when clearAns changes

  useEffect(() => {
    //   first time chat history load
    if (messages.length === 0 && chatHistory.length > 0) {
      setMessages(chatHistory);
    }
    setFeedbackMap([])
  }, [chatHistory]);

  console.log(3);
  const handleClick = () => {
    if (recognition) {
      recognition.stop(); // If already listening, stop it
      setRecognition(null);
      setIsListening(false);
      return;
    }

    const adjustHeight = () => {
      const textarea = textareaRef.current;
      if (textarea) {
        textarea.style.height = "auto";
        textarea.style.height = textarea.scrollHeight + "px";
      }
    };

    // Create a new SpeechRecognition object
    const newRecognition = new (window.SpeechRecognition ||
      window.webkitSpeechRecognition)();

    // Configure SpeechRecognition
    newRecognition.lang = "en-US";
    newRecognition.interimResults = false;
    newRecognition.maxAlternatives = 1;
    newRecognition.continuous = true; // Keep listening until manually stopped

    newRecognition.onstart = () => {
      setIsListening(true);
      
    };

    newRecognition.onresult = (event) => {
      const transcript = event.results[event.results.length - 1][0].transcript;
      setInput((prevInput) => prevInput + " " + transcript);
    
    };

    newRecognition.onend = () => {
      setIsListening(false);
      
    };

    newRecognition.onerror = (event) => {
      console.error("Speech recognition error:", event.error);
    };

    // Start recognition
    newRecognition.start();
    setRecognition(newRecognition);
  };

  //sessionId for chatBot
  function generateRandomNumber() {
   
    const randomNumber = Math.random();
    const scaledNumber = randomNumber * 900000 + 100000;
    const sixDigitNumber = Math.floor(scaledNumber);
    return sixDigitNumber;
  }

  useEffect(() => {
    const textarea = document.querySelector("textarea");

    if (textarea) {
      textarea.addEventListener("keydown", autosize);

      // Clean up the event listener when the component unmounts
      return () => {
        textarea.removeEventListener("keydown", autosize);
      };
    }
  }, []);


  // textarea.addEventListener('keydown', autosize);

  function autosize() {
    var el = this;
    setTimeout(function () {
      el.style.cssText = "height:auto; padding:0";
      // for box-sizing other than "content-box" use:
      // el.style.cssText = '-moz-box-sizing:content-box';
      el.style.cssText = "height:" + el.scrollHeight + "px";
    }, 0);
  }

  const typingIntervalRef = useRef(null); // To store the interval ID

  const handleStopResponse = () => {
    if (typingIntervalRef.current) {
      clearInterval(typingIntervalRef.current); // Stop the typing effect
      typingIntervalRef.current = null; // Reset the interval reference
      setMessages((prev) => {
        const lastMessage = prev[prev.length - 1];
        if (lastMessage.sender === "bot") {
          // Remove the cursor (if any) and mark the message as stopped
          return [
            ...prev.slice(0, -1),
            { ...lastMessage, text: lastMessage.text.replace("|", "") },
          ];
        }
        return prev;
      });
      toast.info("Bot response stopped.");
    }
  };

  const [randomId, setRandomId] = useState();

  // Fetch chat history from API
  const fetchChatHistory = async () => {
    try {
      const response = await fetch(
        // `https://sdeiaiml.com:9036/chat_history?session_id=${randomId}`
        `http://0.0.0.0:9033/chat/chat_history?session_id=${randomId}`
      );

      const data = await response.json();
      
      if (Array.isArray(data?.chat_history) && data?.chat_history.length > 0) {
        
        dispatch(setChatHistory(data?.chat_history)); //  Redux me update karna chahiye
      } else {
        
      }
    } catch (error) {
      console.error("Error fetching chat history:", error);
    }
  };

  const handleSend = async () => {
    const currentInput = input; // store current input
    setInput("");

    const userId = localStorage.getItem("user_id");

    if (input.trim() === "" || isDisabled) return;

    // Add User Message
    const userMessage = { sender: "user", text: input };
    setMessages((prev) => [...prev, userMessage]);

    // Immediately Clear Input Field

    // Add Loader as Bot Message
    const loaderMessage = { sender: "bot", text: "Loading..." , user_query :input 
    };
    setMessages((prev) => [...prev, loaderMessage]);

    const formData = new FormData();
    formData.append("question", input);
    formData.append("session_id", sessionId ? sessionId : randomId);
    formData.append("user_id", userId);
    const token = localStorage.getItem("accessToken");

    try {
      const response = await submitQuery(formData);

    

      const updateFormData = new FormData();
      updateFormData.append(
        "token_used",
        response?.data?.token_usage?.total_tokens
      );
     
      updateFormData.append("user_id", userId);

      // Call update API for used_token
      const result = await dispatch(
        updateCommunityApi({
          formData: updateFormData,
          id: userId,
          token_used: response?.data?.token_usage?.total_tokens,
        })
      );

      const token_used = result?.payload?.data?.token_used;
      const chat_token = result?.payload?.data?.chat_token;

      if (chat_token <= token_used) {
        setIsDisabled(true);
      } else {
        setIsDisabled(false);
      }



      if (messages.length === 0 && sessionData.length === 0) {
       

        const firstMessageToSend = {
          first_message: {
            assistant_response: response.data.result,
            session_id: sessionId,
            user_query: input,
          },
          session: sessionId,
        };


        await dispatch(appendFirstChat(firstMessageToSend));
      }
    setInput("");

      const botResponseText =
        response.data?.result || "Sorry, I couldn't understand that.";

      // Simulate Typewriter Effect
      let index = 0;
      typingIntervalRef.current = setInterval(() => {
        if (index < botResponseText.length) {
          setMessages((prev) =>
            prev.map((msg, i) =>
              i === prev.length - 1
                ? { ...msg, text: botResponseText.slice(0, index + 1) + "|" } // Add cursor
                : msg
            )
          );
          index++;
        } else {
          // Remove cursor when typing is complete
          setMessages((prev) =>
            prev.map((msg, i) =>
              i === prev.length - 1 ? { ...msg, text: botResponseText } : msg
            )
          );
          clearInterval(typingIntervalRef.current);
          typingIntervalRef.current = null;
        }
      }, 5);
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error("Failed to send message. Please try again.");

      // Replace Loader with Error Message
      setMessages((prev) => [
        ...prev.slice(0, -1),
        {
          sender: "bot",
          text: " Error fetching response. Please try again.",
        },
      ]);
    }
  };

  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    }
  }, [input]);

  // Auto-scroll logic
  useEffect(() => {
    if (chatWindowRef.current) {
      chatWindowRef.current.scrollTo({
        top: chatWindowRef.current.scrollHeight,
        behavior: "smooth", //  Smooth scrolling
      });
    }
  }, [messages]); //  Runs whenever messages update

  useEffect(() => {

    if (userDetails?.chat_token <= userDetails?.token_used) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [userDetails]);

  const handleClearChatWindow = async () => {
    await dispatch(setClearAns(true));
    await dispatch(setClearSessionData([]));
    const newSessionId = generateRandomNumber();
    setSessionId(newSessionId); // Set new session ID
  };

  useEffect(() => {
    if (clearAns) {
      setMessages([]);
    }
  }, [clearAns]);

  let itemElements = []; //p
  for (let i = 0; i < sessionData?.length; i++) {
    itemElements.push({
      sender: "user",
      text: sessionData[i]?.user,
    });

    itemElements.push({
      sender: "bot",
      text: sessionData[i]?.assistant,
      user_query: sessionData[i]?.user,
    });
  }

  const handleResize = () => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    textarea.style.height = "auto";

    const minHeight = 24;
    const maxHeight = 200;

    if (textarea.value.trim() === "") {
      textarea.style.height = `${minHeight}px`; // Reset to min height
    } else {
      textarea.style.height = "auto"; // Reset height to auto first
      textarea.style.height = `${Math.min(textarea.scrollHeight, maxHeight)}px`;
    }

    textarea.scrollTop = textarea.scrollHeight; // Always scroll to bottom
  };

  const handleLikeToggle = (index) => {
    setLikedMessages((prev) => {
      const updated = new Set(prev);
      if (updated.has(index)) {
        updated.delete(index);
      } else {
        updated.add(index);
      }
      return updated;
    });
  };

  return (
    <div className="chatContainer justify-content-center m-auto">
      {/* If chat is empty, show default text */}
      {messages?.length === 0 && sessionData?.length === 0 ? (
        <div className="emptyChatMessage">What can I help with?</div>
      ) : (
        <div
          ref={chatWindowRef}
          className={`${
            !isCollapsed ? "chatWindow" : "colChatWindow"
          } overflow-y-scroll`}
        >
          {/* Display either sessionData or messages based on availability */}
          {sessionData?.length > 0 && // If sessionData is available, use itemElements
            itemElements.map((message, index) => (
              <div
                key={index}
                className={`message ${
                  message.sender === "user" ? "userMessage" : "botMessage"
                }`}
              >
                <div className="messageText">
                  <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {typeof message.text === "string"
                      ? message.text
                      : JSON.stringify(message.text)}
                  </ReactMarkdown>
                </div>
                {/* Show feedback only for bot responses */}
                {message.sender === "bot" && message.text !== "Loading..." && (
                  <div className="feedback-icons">
                    <Tooltip title="Good response" arrow>
                      <span>
                        <ThumbsUpIcon
                          className="thumbs-up-icon"
                          onClick={() =>
                            handleFeedback(index, "thumbsUp", message)
                          }
                          style={{
                            fill:
                              feedbackMap[index] === "thumbsUp"
                                ? "blue"
                                : "gray", // Blue when selected, gray otherwise
                            cursor: "pointer",
                          }}
                        />
                      </span>
                    </Tooltip>

                    <Tooltip title="Bad response" arrow>
                      <span>
                        <ThumbsDownIcon
                          className="thumbs-down-icon"
                          onClick={() => handleFeedback(index, "thumbsDown" ,message)}
                          style={{
                            fill:
                              feedbackMap[index] === "thumbsDown"
                                ? "blue"
                                : "gray",
                            cursor: "pointer",
                          }}
                        />
                      </span>
                    </Tooltip>
                  </div>
                )}
              </div>
            ))}

          {/* // If sessionData is empty, fallback to messages */}
          {messages.map((message, index) => (
            <div
              key={index}
              className={`message ${
                message.sender === "user" ? "userMessage" : "botMessage"
              }`}
            >
              <div className="messageText">
                {message.sender === "bot" && message.text === "Loading..." ? (
                  <div className="loader-container">
                    <div className="loader"></div>
                  </div>
                ) : (
                  <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {typeof message.text === "string"
                      ? message.text
                      : JSON.stringify(message.text)}
                  </ReactMarkdown>
                )}
              </div>
              {/* Show feedback only for bot responses */}
              {message.sender === "bot" && message.text !== "Loading..." && (
                <div className="feedback-icons">
                  <Tooltip title="Good response" arrow>
                    <span>
                      <ThumbsUpIcon
                        className="thumbs-up-icon"
                        onClick={() =>
                          handleFeedback(index, "thumbsUp", message)
                        }
                        style={{
                          fill:
                            feedbackMap[index] === "thumbsUp" ? "blue" : "gray", // Blue when selected, gray otherwise
                          cursor: "pointer",
                        }}
                      />
                    </span>
                  </Tooltip>

                  <Tooltip title="Bad response" arrow>
                    <span>
                      <ThumbsDownIcon
                        className="thumbs-down-icon"
                        onClick={() => handleFeedback(index, "thumbsDown",message)}
                        style={{
                          fill:
                            feedbackMap[index] === "thumbsDown"
                              ? "blue"
                              : "gray",
                          cursor: "pointer",
                        }}
                      />
                    </span>
                  </Tooltip>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {isDisabled && (
        <div
          style={{
            color: "#555",
            fontWeight: "bold",
            textAlign: "center",
            paddingRight: "117px",
          }}
        >
          Your daily token limit exceeded. Please try again tomorrow.
        </div>
      )}
      {/* <div className="chatInput w-75 align-items-end gap-3"> */}
      <div
        className={`chatInput align-items-end gap-3 ${
          (sessionData && sessionData.length > 0) || messages.length > 0
            ? "w-100"
            : "w-75"
        }`}
      >
        <div className="input-area">
          <textarea
            className="chatbot-textarea"
            placeholder="Ask Your Query..."
            value={input}
            onChange={(e) => {
              setInput(e.target.value);
              handleResize(); // Trigger auto-resize or conditional resize
            }}
            // onKeyDown={(e) => e.key === "Enter" && handleSend()}
            onKeyDown={(e) => {
              if (e.shiftKey && e.key === "Enter") {
                e.preventDefault();
                setInput((prev) => prev + "\n");

                setTimeout(() => {
                  if (textareaRef.current) {
                    textareaRef.current.style.height = "auto";
                    textareaRef.current.style.height = `${Math.min(
                      textareaRef.current.scrollHeight,
                      200
                    )}px`;

                    // 💡 Ensure proper scroll and focus
                    textareaRef.current.selectionStart =
                      textareaRef.current.value.length;
                    textareaRef.current.selectionEnd =
                      textareaRef.current.value.length;
                    textareaRef.current.focus();
                    textareaRef.current.scrollTop =
                      textareaRef.current.scrollHeight;
                  }
                }, 0);
              } else if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                handleSend();
              }
            }}
           
          ></textarea>

          <div>{/* You can add more input handling code here if needed */}</div>
          {/* Mic button */}
          <IconButton
            onClick={handleClick}
            className="position-relative mic-btn"
          >
            <FaMicrophone
              style={{
                color: isListening ? "blue" : "#414141",
                height: "20px",
                width: "20px",
              }}
            />
          </IconButton>
        </div>

        {/* Send button */}

        <button
          onClick={typingIntervalRef.current ? handleStopResponse : handleSend}
          style={{
            backgroundColor:
              isDisabled || input.trim() === "" ? "#7D99FF" : "blue",
            color: "white",
          }}
          disabled={isDisabled && !typingIntervalRef.current} // Disable only if no action is possible
          className="button"
        >
          {typingIntervalRef.current ? "Stop" : "Submit"}
        </button>
      </div>

      {/* Desclaimer*/}
      <p
      //tooltip add karna hai
        style={{
          fontSize: "18px",
          // color: "rgb(224, 23, 23)",
          color: "#d10505",
          textAlign: "center",
          margin: 0,
          cursor : "pointer",

        }}
        title="Click to view Privacy Policy"
        onClick={ () => navigate("/privacy-policy")}
      >
        ⚠️ Disclaimer: This is not HIPAA compliant do not put any client
        information.
      </p>

      <div className="side-newchat">
        <img src={newChat} onClick={handleClearChatWindow} />
      </div>
      <ToastContainer />

      {/* Feedback Popup */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup">
            <p>
              Are you sure you want to{" "}
              {feedbackType === "thumbsUp" ? "like 👍" : "dislike 👎"} this
              response?
            </p>
            <div
              style={{ display: "flex", gap: "10px", justifyContent: "center" }}
            >
              <button onClick={handleSubmitFeedback}>Yes</button>
              {/* <button onClick={() => setShowPopup(false)}>Cancel</button> */}
              <button
                onClick={() => {
                  setShowPopup(false);
                  setFeedbackType(null);
                  setSelectedFeedback(null);
                  setFeedbackMap((prev) => {
                    const newMap = { ...prev };
                    delete newMap[selectedFeedback];
                    return newMap;
                  });
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

        <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Privacy Policy</Modal.Title>
        </Modal.Header>
        <Modal.Body>
         <PrivacyPolicyPage/>
         {/* click click here to check box to accept policy  */}
          <div style={{ marginTop: "10px" }}>
            <input
              type="checkbox"
              id="acceptPolicy"
              checked={acceptPolicy}
              onChange={handleAcceptPolicyChange}
            />
            <label htmlFor="acceptPolicy" style={{ marginLeft: "5px" }}>
              I accept the Privacy Policy
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
                   <Button variant="secondary" onClick={handleAcceptPolicy}>
            Accept
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default Chatbot;
